import { render, staticRenderFns } from "./HeroEvents.vue?vue&type=template&id=43dc0f8d&scoped=true&"
import script from "./HeroEvents.vue?vue&type=script&lang=js&"
export * from "./HeroEvents.vue?vue&type=script&lang=js&"
import style0 from "./HeroEvents.vue?vue&type=style&index=0&id=43dc0f8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dc0f8d",
  null
  
)

export default component.exports